<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'700px'"
    :classDialog="'dialogTransferHandling'"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #header>
      <h3 class="dialogTitle margin-left-10">
        Chuyển xử lý văn bản
      </h3>
    </template>

    <template #body>
      <div class="">
        <el-form
          ref="form"
          :model="form"
          :rules="validationRules"
          label-position="left"
          label-width="100px"
        >
          <el-form-item
            prop="quote"
            label="Trích yếu"
          >
            <el-input
              v-model="quote"
              type="textarea"
              autosize
              resize="none"
              placeholder="Nhập trích yếu văn bản"
              maxlength="2000"
              :class="[
            'input-border__radius__0',
            quote ? 'has-border__bottom' : 'input-border__bottom',
            'input-border__bottom'
          ]"
              size="medium"
              readonly
            />
          </el-form-item>
          <el-form-item class="margin-bottom-5" label="Người xử lý" prop="handler">
            <el-select
              filterable
              class="style-fullWidth"
              v-model="form.handler"
              placeholder="-"
              clearable
              value-key="id"
              :disabled="isDisabledOrNot"
            >
              <el-option
                v-for="item in handlers"
                :key="item.id"
                :value="item"
                :label="receiverHandlerLabel(item)"
              >

                <div
                  class="flex-row flex__left padding-right-10 inline-block"
                >
                        <span class="font-size__medium">{{
                            item.userView.fullName
                          }}</span>
                  <span class="font-size__small"
                  >({{
                      item.userView.positionName +
                      " - " +
                      item.userView.deptName
                    }})</span>
                  <span style="position: relative;top:-10px;left: 0px;">
                           <el-tooltip
                             v-if="item.userView.absentCount&&item.userView.absentCount!=0"
                             :content="tooltipContent(item.userView)"
                             placement="right"
                             effect="dark">
                           <absent-notify></absent-notify>
                         </el-tooltip>
                      </span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Ý kiến/đề xuất">
            <el-input
              v-model="form.content"
              type="textarea"
              rows="5"
              placeholder="_"
              maxlength="400"
            ></el-input>
          </el-form-item>

        </el-form>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__between">
        <div class="note">
          <em class="font-italic font-size__small">
            <span class="color__red">(*)</span> Xác nhận Ký số trên văn bản này
            và chuyển xử lý</em
          >
        </div>
        <div class="flex-row flex__right form-button__action margin-top-10">
<!--          <el-button-->
<!--            class="dialogBtnPrimary"-->
<!--            @click="chuyenXuLi"-->
<!--            :disabled="isProcessing"-->
<!--          >-->
<!--            <i-->
<!--              :class="[-->
<!--                !isProcessing-->
<!--                  ? 'fas fa-check-circle font-size__small'-->
<!--                  : 'el-icon-loading'-->
<!--              ]"-->
<!--            ></i>-->
<!--            &nbsp;Xác nhận-->
<!--          </el-button>-->
          <el-button
            class="dialogBtnPrimary"
            @click="submit"
            :disabled="isProcessing"
          >
            <i
              :class="[
              !isProcessing
                ? 'fas fa-check-circle font-size__small'
                : 'el-icon-loading'
            ]"
            ></i>
            &nbsp;Xác nhận
          </el-button>
        </div>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import nextStepInfoViewService from "../../../services/nextStepInfoViewService";
import h from "../../../services/h";
import vbFlowInstanceService from "../../../services/vbFlowInstanceService";
import AbsentNotify from "../../common/absents/absent-notify";
import dateFormatter from "../../../filters/dateFormatter";

import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import cxlVbdenCommonMixin from "../../../mixins/cxlVbdenCommonMixin";
import vbStepService from "../../../services/vbStepService";
import utils from "../../../services/utils";
import vbFlowService from "../../../services/vbFlowService";

export default {
  name: "DocInSelectHandler",
  mixins: [cxlVbdenCommonMixin],
  props: ["vbIncomingProcess", "isOpen", "quote"],
  components: {
    AbsentNotify,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    Multiselect: () => import("vue-multiselect")
  },

  data() {
    return {
      handlers: [],
      nextSteps: [],
      isProcessing: false,
      vbFlowInstance: null,
      flowId: null,
      flow: null,
      isDisabledOrNot: false,
      form: {
        handler: null,
        content: null
      },

      validationRules: {
        handler: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          }
        ]
      },
      vbStep: null,
      docId:null,
      stepId:null,
      flowInstanceId:null
    };
  },

  async created() {
    await this.loadData();
    await this.loadFlowInstance();
    await this.loadVbStep();
    // await this.loadNextSteps();
    await this.loadFlow();
    await this.setDefaultHandler();
    this.initForm();
  },

  methods: {

    async loadData(){
      this.docId = this.vbIncomingProcess.docId;
      this.stepId = this.vbIncomingProcess.stepId;
      this.flowInstanceId = this.vbIncomingProcess.flowInstanceId;
    },

    async setDefaultHandler() {
      await userDeptRoleViewService.findActiveById(this.vbIncomingProcess.receiverUserDeptRoleId)
        .then(response => {
          console.log('response.data',response.data);
          this.handlers = this.handlers.concat(
            h.collect([response.data], userView => {
              return {
                id: userView.id,
                userView: userView,
                stepId: this.vbIncomingProcess.stepId
              };
            })
          );
        })
      if (this.handlers.length === 1) {
        this.form.handler = this.handlers[0]
        this.isDisabledOrNot = true
      }
    },

    loadFlow() {
      return vbFlowService
        .findById(this.flowId)
        .then(response => (this.flow = response.data));
    },

    initForm() {
      let content =
        this.flow.flowType === constants.FLOW_TYPE.DONG_TRINH
          ? ""
          : errorMessageFilter({
            errorCode: "vbOutgoingDoc.defaultSignContent2"
          });
      this.form.content = content;
    },

    receiverHandlerLabel(option) {
      let usersView = option.userView;

      return `${usersView.fullName} (${usersView.positionName} - ${
        usersView.deptName
      })`;
    },
    tooltipContent(item) {
      return `Vắng mặt từ ` + dateFormatter(item.absentStartTime) + ` đến ` + dateFormatter(item.absentDeadlineTime);
    },

    loadVbStep() {
      return vbStepService
        .findById(this.stepId)
        .then(response => (this.vbStep = response.data));
    },


    loadFlowInstance() {
      return vbFlowInstanceService
        .findById(this.flowInstanceId)
        .then(response => {
          this.vbFlowInstance = response.data;
          this.flowId = this.vbFlowInstance.flowId;
        });
    },

    handlerChange(event) {
      this.$nextTick(() => this.$refs.form.validateField("handler"));
    },

    submit() {
      // const handlersData = this.processSelectedHandlerData(this.selectedHandlersData);
      let handlersData = [];
      this.handlers.forEach(item =>{
        handlersData.push({
          userDeptRole:item.userView,
          processType:this.vbIncomingProcess.processType,
          stepId:this.stepId,
          stepType: constants.STEP.STEP_TYPE.CANHAN
        })
      })
      this.$emit("submit",
        {
          handlersData: handlersData,
          note: this.form.content
        }
      );
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    loadNextSteps() {
      return nextStepInfoViewService
        .nextSteps(this.flowId, this.stepId)
        .then(response => {
          this.nextSteps = response.data;
          h.each(this.nextSteps, item => this.loadUsersForNextStep(item));
        })
    },

    loadUsersForNextStep(nextStep) {
      userDeptRoleViewService
        .findAllActiveForStepInfo(nextStep.vbStepInfoId)
        .then(response => {
          this.handlers = this.handlers.concat(
            h.collect(response.data, userView => {
              return {
                id: userView.id,
                userView: userView,
                stepId: nextStep.id
              };
            })
          );
        })
    },

    receiverLabel(option) {
      let usersView = option.userView;
      return `${usersView.fullName} (${usersView.positionName} - ${
        usersView.deptName
      })`;
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/components/DocInSelectHandler.vue